const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "EPIRB_MOUNTING_TYPES_RETRIEVED":
            return action.epirbMountings;

        default:
            return state;
    }
}
